import dayjs from 'dayjs';
/**
 * function to format game_startsAt to DD.MM.YYYY or DD.MM.YYYY HH:mm
 * @param {string} dateString
 * @param {boolean} showOnlyDate
 * @returns {dayjs.Dayjs}
 */
export function formatTime(dateString: string, showOnlyDate?: false): string {
  const date = dayjs(dateString);

  if (showOnlyDate) {
    return date.format('DD.MM.YYYY');
  }

  return date.format('DD.MM.YYYY HH:mm');
}
